var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-body" }, [
    _c(
      "section",
      { staticClass: "item-card" },
      [
        _c("page-limiter", [
          _c(
            "div",
            { staticClass: "breadcrumbs-box" },
            [
              _vm.crumbs && _vm.crumbs.length
                ? _c("breadcrumbs", { attrs: { crumbs: _vm.crumbs } })
                : _vm._e(),
              _c("btn-back", { attrs: { path: _vm.page.prevPagePath } })
            ],
            1
          ),
          _vm.item
            ? _c(
                "div",
                { staticClass: "item-card__body" },
                [
                  _c(
                    "div",
                    { staticClass: "item-card__row" },
                    [
                      _c("div", { staticClass: "item-card__row-images" }, [
                        _c("div", { staticClass: "item-card-box-slider" }, [
                          _vm.item && _vm.item.images.length
                            ? _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "swiper",
                                      rawName: "v-swiper:itemCardCarousel",
                                      value: _vm.itemCardCarouselOptions,
                                      expression: "itemCardCarouselOptions",
                                      arg: "itemCardCarousel"
                                    }
                                  ],
                                  staticClass: "item-card-slider"
                                },
                                [
                                  _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "swiper-wrapper item-card-slider__row"
                                    },
                                    _vm._l(_vm.item.images, function(image) {
                                      return _c(
                                        "li",
                                        {
                                          staticClass:
                                            "swiper-slide item-card-slider__item"
                                        },
                                        [
                                          _c("img", {
                                            staticClass:
                                              "item-card-slider__image",
                                            attrs: { src: image, alt: "" }
                                          })
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _c("div", { staticClass: "item-card__row-description" }, [
                        _c("h2", { staticClass: "item-card__title" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.item.h1 ? _vm.item.h1 : _vm.item.title
                              ) +
                              "\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "item-card__flavor" }, [
                            _vm._v(_vm._s(_vm.item.flavor))
                          ])
                        ]),
                        _vm.item.info && _vm.item.info.length
                          ? _c("div", { staticClass: "item-card__tabs" }, [
                              _c(
                                "div",
                                { staticClass: "item-card__tabs-head" },
                                _vm._l(_vm.item.info, function(tab, index) {
                                  return _c(
                                    "btn",
                                    {
                                      key: "tab-" + index,
                                      class: [
                                        "item-card__tabs-title",
                                        _vm.activeTabIndex === index
                                          ? "btn--primary"
                                          : "btn--outline"
                                      ],
                                      attrs: { tag: "control" },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.setTab(index)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(tab.title) +
                                          "\n\n\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                }),
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "item-card__tabs-body" },
                                _vm._l(_vm.item.info, function(tab, index) {
                                  return _c(
                                    "div",
                                    {
                                      class: [
                                        "item-card__tabs-tab",
                                        {
                                          "item-card__tabs-tab--active":
                                            _vm.activeTabIndex === index
                                        }
                                      ]
                                    },
                                    [
                                      tab.meta && tab.meta.length
                                        ? _c(
                                            "ul",
                                            { staticClass: "item-card__meta" },
                                            _vm._l(tab.meta, function(prop) {
                                              return _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "item-card__meta-item"
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(prop.title) + ":"
                                                    )
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(prop.value) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                }),
                                0
                              ),
                              _c("div", { staticClass: "item-card__intro" }, [
                                _c("p", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.item.intro) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ])
                              ])
                            ])
                          : _vm._e()
                      ]),
                      _vm.prevNext[0]
                        ? _c("nuxt-link", {
                            staticClass: "item-card__prev",
                            attrs: {
                              to: "/" + _vm.baseUrl + "/" + _vm.prevNext[0]
                            },
                            nativeOn: {
                              click: function($event) {
                                return _vm.setTab(0)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm.prevNext[1]
                        ? _c("nuxt-link", {
                            staticClass: "item-card__next",
                            attrs: {
                              to: "/" + _vm.baseUrl + "/" + _vm.prevNext[1]
                            },
                            nativeOn: {
                              click: function($event) {
                                return _vm.setTab(0)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("page-content", {
                    attrs: { page: _vm.item, color: "cacao" }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ],
      1
    ),
    _c(
      "section",
      {
        directives: [{ name: "scroll-reveal", rawName: "v-scroll-reveal" }],
        staticClass: "rec-items-section"
      },
      [
        _vm.recItems
          ? [
              _c("h3", { staticClass: "rec-items-section__title" }, [
                _vm._v(_vm._s(_vm.recItems.title))
              ]),
              _vm.recItems.items && _vm.recItems.items.length
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "swiper",
                          rawName: "v-swiper:recItemsCarousel",
                          value: _vm.recItemsCarouselOptions,
                          expression: "recItemsCarouselOptions",
                          arg: "recItemsCarousel"
                        }
                      ],
                      staticClass: "rec-items-slider"
                    },
                    [
                      _c(
                        "ul",
                        { staticClass: "swiper-wrapper rec-items-slider__row" },
                        _vm._l(_vm.recItems.items, function(item) {
                          return _c(
                            "li",
                            {
                              staticClass:
                                "swiper-slide rec-items-slider__item",
                              class: [
                                "swiper-slide",
                                "rec-items-slider__item",
                                { "rec-items-slider__item--wide": item.wide }
                              ]
                            },
                            [_c("product-tile", { attrs: { content: item } })],
                            1
                          )
                        }),
                        0
                      ),
                      _c("div", { staticClass: "swiper-pagination" })
                    ]
                  )
                : _vm._e()
            ]
          : _vm._e()
      ],
      2
    ),
    _c(
      "section",
      [
        _c(
          "page-limiter",
          [
            _c("feedback-tile", {
              directives: [
                { name: "scroll-reveal", rawName: "v-scroll-reveal" }
              ]
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6deb1c72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6deb1c72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageCatalogInner.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6deb1c72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageCatalogInner.vue
// module chunks = 1 2